import useCommonClassName from './use-common-classname.js';
import 'react';
import './use-config.js';
import '../_chunks/dep-50ece1d9.js';

function useSizeProps(size) {
  var COMMON_SIZE_CLASS_NAMES = useCommonClassName().SIZE;
  if (typeof size === "undefined") {
    return {};
  }
  if (!(size in COMMON_SIZE_CLASS_NAMES)) {
    return {
      className: "",
      style: {
        width: size,
        height: size
      }
    };
  }
  return {
    className: COMMON_SIZE_CLASS_NAMES[size],
    style: {}
  };
}

export { useSizeProps as default };
//# sourceMappingURL=use-size-props.js.map
